/*
  src/redux/impersonate/actions.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/
import Cookies from 'js-cookie';

import {
  TOKEN_LOADED_FROM_COOKIE,
  TOKEN_FAILED_TO_LOAD_FROM_COOKIE,
  TOKEN_REQUESTED,
  TOKEN_LOADED,
  TOKEN_FAILED_TO_LOAD,
  TOKEN_INVALIDATED,
  IMPERSONATION_CEASED
} from './constants';

import callAPI from '../callAPI';

export function loadImpersonateTokenFromCookie(){
  const token = Cookies.get('impersonateToken'),
    email = Cookies.get('impersonatePrincipal');

  if(token && email){
    return {
      type:TOKEN_LOADED_FROM_COOKIE,
      payload:{
        token,
        email
      }
    };
  } else {
    return {
      type:TOKEN_FAILED_TO_LOAD_FROM_COOKIE
    }
  }
}

export function invalidateImpersonateToken(){
  Cookies.remove('impersonateToken');
  Cookies.remove('impersonatePrincipal');

  return {
    type:TOKEN_INVALIDATED
  };
}

export function requestImpersonateTokenWithCredentials(email){
  Cookies.set('impersonatePrincipal',email);

  return callAPI({
    path:`/sys/v1/user/impersonate?email=${encodeURIComponent(email)}`,
    begin:{
      type:TOKEN_REQUESTED,
      payload:() => email
    },
    success:{
      type:TOKEN_LOADED,
      payload:(res) => res.access_token,
      result:(res) => Cookies.set('impersonateToken',res.access_token)
    },
    failure:{
      type:TOKEN_FAILED_TO_LOAD
    }
  });
}

export function ceaseImpersonation(){
  return {
    type:IMPERSONATION_CEASED
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/impersonate/actions.js